import { render, staticRenderFns } from "./SorryPopup.vue?vue&type=template&id=58b1c0ea&scoped=true"
import script from "./SorryPopup.vue?vue&type=script&lang=js"
export * from "./SorryPopup.vue?vue&type=script&lang=js"
import style0 from "./SorryPopup.vue?vue&type=style&index=0&id=58b1c0ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b1c0ea",
  null
  
)

export default component.exports